module.exports = __webpack_public_path__ + "img/australia-skin-connective-and-musculoskeletal-diseases-male.e386cf68.png";